
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export const TemplatesTab = () => {
  const { t } = useTranslation('offerManagement');
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("templates.title")}</CardTitle>
        <CardDescription>
          {t("templates.description")}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">{t("templates.noTemplates")}</p>
      </CardContent>
    </Card>
  );
};
